export function defaultHeader() {
    return ({
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("accessToken")
        }
    })
}

export function authenticatedHeader() {
    return ({
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("accessToken")
        },
        withCredentials: true
    })
}

export const GOOGLE_CLIENT_ID = "449164179583-lmgulr47pnn8papo7ehmt3ljp8javin5.apps.googleusercontent.com"

export const GOOGLE_CAPTCHA_ID = "6Ldf1DwmAAAAAGM8uw0dMqYjzfdOrwv5mbf50Pyj"